// extracted by mini-css-extract-plugin
export var actions = "_4f-0";
export var actionsContainer = "_4f-7";
export var border = "_4f-1";
export var childFullHeight = "_4f-f";
export var collapse = "_4f-2";
export var content = "_4f-a";
export var contentChild = "_4f-e";
export var fullscreen = "_4f-c";
export var hasLeftRadius = "_4f-k";
export var headerContainer = "_4f-3";
export var headerRow = "_4f-5";
export var hidePadding = "_4f-b";
export var navCollapsedGap = "_4f-l";
export var noScrollX = "_4f-m";
export var noScrollY = "_4f-n";
export var noTopPadding = "_4f-i";
export var optOutTopPadding = "_4f-d";
export var pageMain = "_4f-j";
export var pageOuter = "_4f-g";
export var pagePadding = "_4f-8";
export var pageScroll = "_4f-9";
export var profile = "_4f-o";
export var profileContainer = "_4f-p";
export var profileImage = "_4f-q";
export var profileMain = "_4f-r";
export var profileSubtitle = "_4f-t";
export var profileTitle = "_4f-s";
export var showLeftPadding = "_4f-h";
export var tabsPortalSlot = "_4f-6";
export var tabsWrapper = "_4f-4";
export var title = "_4f-u";